export class ChangePasswordModel {
  public oldPassword: string;
  public newPassword: string;
  public confirmNewPassword: string;
}
